import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import { showToast } from '../../config_and_helpers/helpers';
import { logInfo } from '../../config_and_helpers/logger';
import { moveSelectedLots } from '../../utils/moveStockItems';
import StoragePlaceSelect from '../Product/StoragePlaceSelect';

const LOG_CONTEXT = 'StorageLotMoveBar';

/**
 * Destination for the lots currently selected in a place or on a slot chart.
 *
 * @param {Object} props
 * @param {string} props.token
 * @param {Array} props.nodes
 * @param {Array} props.lots
 * @param {Function} props.onMoved - ({ moved, failed, storageNodeId }) => void
 */
const StorageLotMoveBar = ({ token, nodes = [], lots = [], onMoved }) => {
  const [place, setPlace] = useState({ storageNodeId: null, slotIndex: null });
  const [saving, setSaving] = useState(false);
  if (!lots.length) return null;

  const label = lots.length === 1 ? '1 lot selected' : `${lots.length} lots selected`;

  const move = async () => {
    setSaving(true);
    logInfo(LOG_CONTEXT, 'move selected lots', {
      lotCount: lots.length,
      storageNodeId: place.storageNodeId ?? null,
      slotIndex: place.slotIndex ?? null,
    });
    const result = await moveSelectedLots({
      token,
      nodes,
      lots,
      storageNodeId: place.storageNodeId,
      slotIndex: place.slotIndex,
    });
    setSaving(false);
    if (result.error) {
      showToast(result.error, 'warning', 'top-right', 4000);
      return;
    }
    if (result.failed.length) {
      const name = result.failed
        .map(lot => lot.cat_num || lot.batch || lot.id)
        .join(', ');
      showToast(`Could not move ${name}`, 'warning', 'top-right', 4500);
    } else {
      showToast(
        result.moved.length === 1 ? 'Lot moved' : `${result.moved.length} lots moved`,
        'success',
        'top-right',
        2500
      );
    }
    onMoved?.({
      moved: result.moved,
      failed: result.failed,
      storageNodeId: place.storageNodeId,
    });
  };

  return (
    <div className="storage-lot-move-bar">
      <span className="storage-lot-move-bar__count">{label}</span>
      <StoragePlaceSelect
        nodes={nodes}
        idPrefix="lot-move"
        storageNodeId={place.storageNodeId}
        slotIndex={place.slotIndex}
        onChange={setPlace}
      />
      <Button
        size="sm"
        className="glass-primary-btn"
        disabled={saving}
        onClick={move}
      >
        {saving ? <Spinner animation="border" size="sm" /> : 'Move'}
      </Button>
    </div>
  );
};

export default StorageLotMoveBar;
